import { collection, doc, getDoc, getDocs } from "firebase/firestore"
import { firebaseDb } from "./init"

const topicRef = (id) => doc(firebaseDb, "topics", id)

export async function getTopicById(id) {
  const topicDoc = topicRef(id)
  const topicSnapshot = await getDoc(topicDoc)
  const topicData = topicSnapshot.data()

  return { ...topicData, id: courseSnapshot.id }
}

export async function getAllTopics() {
  const topicDoc = collection(firebaseDb, "topics")
  const topicSnapshot = await getDocs(topicDoc)

  return topicSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
}